import {
    ChangeDetectionStrategy,
    Component,
    ElementRef,
    HostListener,
    Input,
    ViewChild,
    input,
} from '@angular/core';
import { IconModule } from '@bazis/shared/components/web/icon/icon.module';
import { ButtonModule } from '@bazis/shared/components/web/button/button.module';
import { ColorDirective } from '@bazis/shared/directives/color.directive';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@jsverse/transloco';
import { ClickOutsideDirective } from '@bazis/shared/directives/click-outside.directive';
import { LinkModule } from '../web/link/link.module';
import { SizeRange } from '@bazis/shared/models/base.types';

@Component({
    selector: 'bazis-dropdown-actions',
    templateUrl: './dropdown-actions.component.html',
    imports: [
        IconModule,
        ButtonModule,
        IconModule,
        ColorDirective,
        CommonModule,
        TranslocoModule,
        ClickOutsideDirective,
        LinkModule,
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BazisDropdownActionsComponent {
    // ключ заголовка триггера, не обязательный
    readonly titleKey = input<string>();

    // параметры заголовка триггера, не обязательный
    readonly titleParams = input<string>();

    // размер кнопки триггера, не обязательный, будет использован дефолтный
    readonly sizeTrigger = input<SizeRange>();

    // заполненность кнопки триггера, не обязательный, будет использован fill=solid
    readonly fillTrigger = input<string>();

    // цвет кнопки триггера, применение директивы color, не обязательный, не будет примененена
    readonly colorTrigger = input<string>();

    // иконка кнопки триггера, не обязательный, если есть заголовок
    readonly iconEnd = input<string>('menu-dots');

    // иконка кнопки триггера (slot=start), не обязательный
    readonly iconStart = input<string>();

    // размер иконки триггера, не обязательный
    readonly iconSize = input<SizeRange>(SizeRange.regular);

    // направление выпадения
    readonly direction = input<'bottom' | 'top'>('bottom');

    readonly typeTrigger = input<'button' | 'link'>('button');

    @HostListener('click', ['$event.target'])
    public onClick(targetElement) {
        if (this.triggerEl && targetElement !== this.triggerEl) {
            this.hideDropdown();
        }
    }

    @ViewChild('trigger') set trigger(el: ElementRef) {
        if (!el) return;

        this.triggerEl = el.nativeElement;
    }

    open = false;

    triggerEl;

    toggleDropdown(e) {
        this.open = !this.open;
    }

    hideDropdown() {
        this.open = false;
    }
}
